import { ShelterAttListRoutingModule } from './shelter-att-list-routing.module';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { ShelterAttListComponent } from './shelter-att-list.component';
import { BatchActionsService } from 'Src/ng2/school/lists/services/batch-actions/batch-actions.service';
import { ShelterDataService } from './shelter-attendance-data/shelter-attendance-data.service';
import { MadlibService } from 'Src/ng2/school/lists/services/madlib/madlib.service';
import { ListHeaderService } from 'Src/ng2/school/lists/services/list-headers/list-headers.service';
import { NgRouterNavigationService } from 'Src/ng2/school/lists/services/list-navigation/ng-router-list-navigation.service';
import { MadlibModule } from 'Src/ng2/shared/components/list/mad-lib/mad-lib.module';
import { CommonModule } from '@angular/common';
import { PageHeaderModule } from 'Src/ng2/shared/components/header/page-header/page-header.module';
import { ListSummaryModule } from 'Src/ng2/shared/components/list-summary/list-summary.module';
import { ContentToolsModule } from 'Src/ng2/shell/content-tools/content-tools.module';

@NgModule({
  declarations: [ShelterAttListComponent],
  imports: [ShelterAttListRoutingModule, MadlibModule, CommonModule, PageHeaderModule, ContentToolsModule],
  exports: [ShelterAttListComponent],
  providers: [
    ShelterDataService,
    BatchActionsService,
    MadlibService,
    ListHeaderService,
    NgRouterNavigationService,
    ListSummaryModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class ShelterAttListModule {}
